const search = {
    state:{
        showSuggest:false,
        showHistory:false,
        searchson:'',
    },
    mutations:{
      changeSuggest(state,data){
        state.showSuggest = data
      },
      changeHistory(state,data){
        state.showHistory = data
      },
      sonsearch(state,data){
          state.searchson = data
      },
      clearsonsearch(state,data){
          state.searchson = data;
      }
     
    }
  }
  export default search
  


// WEBPACK FOOTER //
// ./src/stroe/modules/search.js